<div class="modal--wrap panel-show"
     ngxModalDraggable
     [expand]="false"
>
  <app-modal-header
  icon="copy"
  title="Выделите нужные слова"
  [modalDirective]="modalDirective"
  [bsModalRef]="bsModalRef"
  [expand]="false"
  ></app-modal-header>
  <div class="modal-body p-0">
    <div class="scroll-sidebar" #scroll>
      <div class="d-flex align-items-center">
        <div class="px-5 py-5 text-break" [innerHTML]="text"></div>
      </div>
    </div>
  </div>
</div>